import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} vendorCode
 */
function useMarketIndex(vendorCode) {
  const { cb, key } = fetch(vendorCode);
  const { data, isSuccess, refetch, isLoading, error } = useQuery(key, cb, {
    enabled: !!vendorCode,
    staleTime: 10_000,
    cacheTime: 10_000,
  });

  return { data, isSuccess, refetch, isLoading, error };
}

export default {
  useMarketIndex,
};
